// src/components/auth/ProtectedRoute.js

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";
import { CircularProgress, Box } from "@mui/material"; // Optional: Add a loading indicator

const ProtectedRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);
  const location = useLocation(); // Get the current location

  if (loading) {
    // Optional: You can add a loading spinner or skeleton here
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    // Redirect to sign-in page and pass the current location in state
    return (
      <Navigate to="/challenge/signin" state={{ from: location }} replace />
    );
  }

  return children;
};

export default ProtectedRoute;
